var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contents && _vm.contents.length === 1)?_c('ContentPage',{attrs:{"content":_vm.contents[0]}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }